import { Component, HostListener, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { CommonSettings, INCPCCPayment } from 'epay-library';
import { IConfirmationNumber } from 'src/app/features/ncp/components/creditcard/payment/ncpcredit-card-common/confirmation-number';
import { EpayExtendedServiceService } from 'src/app/helpers/services/epay-extended-service.service';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'epay-creditcard-success',
  templateUrl: './creditcard-success.component.html'
})
export class CreditCardSuccessComponent implements OnInit, OnDestroy {
  @Input() creditCardPayment: INCPCCPayment = {} as INCPCCPayment;
  pagetitle = "Credit Card Payment Success";
  baseurl = CommonSettings.BaseApi;
  clientId = CommonSettings.ClientID;

  paymentDate: Date = new Date();
  confirmationId: string = '';
  totalAmount: number = 0;
  transactionId: string = '';
  firstName: string = '';
  lastName: string = '';
  fullName: string = '';

  private navSubscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private paymentService: EpayExtendedServiceService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    // DO NOT remove sessionStorage here. Keep until user navigates away.
    sessionStorage.setItem('cameFromSuccessPage', 'true');
    this.paymentDate = new Date();
    this.firstName = sessionStorage.getItem('firstName') || '';
    this.lastName = sessionStorage.getItem('lastName') || '';
    this.fullName = [this.firstName, this.lastName].filter(Boolean).join(' ');

    this.route.queryParams.subscribe(params => {
      const confirmationNumber = params['id'];
      const transactionId = params['externalId'];
      const totalAmountParam = params['amount'];

      if (totalAmountParam) {
        this.totalAmount = parseFloat(totalAmountParam);
      }

      if (confirmationNumber && transactionId) {
        this.confirmationId = confirmationNumber;
        this.transactionId = transactionId;

        const payload: IConfirmationNumber = {
          clientId: this.clientId,
          transactionId,
          confirmationNumber
        };

        this.paymentService.postUpdateConfirmationNumber(this.baseurl, payload).subscribe({
          next: (res: any) => {
            // Success handled silently
          },
          error: (err: any) => {
            console.error('Failed to update confirmation number:', err);
          }
        });
      } else {
        console.warn('Missing confirmationNumber or transactionId in query params.');
      }
    });

    // Listen for navigation events to prevent going back to iframe
    this.navSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url.includes('/ncp/creditcard/iframe-fort-point')) {
          console.warn('[CreditCardSuccessComponent] Preventing navigation back to iframe, redirecting to /home');
          this.router.navigate(['/home'], { replaceUrl: true });
        }
      }
    });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: PopStateEvent): void {
    console.warn('[SuccessComponent] Back button used. Redirecting to /home');
    this.router.navigate(['/home'], { replaceUrl: true });
  }

  GoToHomePage() {
    this.router.navigateByUrl('home');
  }

  Print() {
    window.print();
  }

  ngOnDestroy(): void {
    this.navSubscription?.unsubscribe();
    // Now it's safe to clear session data
    sessionStorage.removeItem('transactionId');
    sessionStorage.removeItem('creditCardPayment');
    sessionStorage.removeItem('cameFromSuccessPage');
  }
}
